import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { RevalidateDot } from '../RevalidateDot/RevalidateDot.jsx';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * Autosave indicator.
 *
 * @param {object} p
 * @param {'idle'|'saving'|'saved'|'error'} [p.state]
 * @param {() => void} [p.onRetry]
 * @param {string} [p.savedLabel]
 * @param {React.CSSProperties} [p.style]
 */
export function SaveState({ state = 'idle', onRetry, savedLabel = 'Saved', style }) {
  const S = { display: 'inline-flex', alignItems: 'center', gap: 6, fontFamily: BODY, fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap', ...style };
  if (state === 'saving') return h('span', { role: 'status', style: { ...S, color: 'var(--mut2)' } }, h(RevalidateDot, { size: 12, title: 'Saving' }), 'Saving…');
  if (state === 'saved') return h('span', { role: 'status', key: 'saved', className: 'gx-saved', style: { ...S, color: 'var(--lime-tx)' } }, h(Icon, { name: 'check', size: 14, stroke: 2.6 }), savedLabel);
  if (state === 'error') return h('span', { role: 'alert', style: { ...S, color: 'var(--coral-tx)' } }, h(Icon, { name: 'circle-alert', size: 14 }), 'Couldn’t save', onRetry ? h('button', { type: 'button', onClick: onRetry, style: { border: 0, background: 'none', padding: 0, font: 'inherit', color: 'inherit', textDecoration: 'underline', textDecorationThickness: 2, textUnderlineOffset: 2, cursor: 'pointer' } }, 'Retry') : null);
  return h('span', { style: { ...S, color: 'var(--mut3)' } }, h(Icon, { name: 'check', size: 14 }), 'All changes saved');
}
